import React, { Component } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  ListItemIcon,
  Icon,
  Avatar,
  Drawer,
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Divider, List, ListItem, ListItemText } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {
  ExecuteLayoutEventMethods,
  GetControlPropertyFromStoreOrRefData,
} from "../../General/commonFunctions";
import PureJSComponentFactory from "../Pages/Factory/pureJSComponentFactory";
import { appTheme, appDrawerWidth, loginImage, versionDatetime } from "../../General/globals";
import FactsGlobalSearchField from "./Controls/factsGlobalSearchField";
import { t } from "../../dictionary/translator.js";

class AppBarComponentDTP extends Component {
  constructor(props) {
    super(props);
    this.currentMenuRef = React.createRef();
    this.state = {
      isDrawerOpen: true,
      openedMenus: [],
      currentSubmenuId: null,
    };
    let DrawerVisibility = localStorage.getItem("wasDrawerVisible");
    if (DrawerVisibility == "true") {
      this.state.isDrawerOpen = true;
    } else {
      this.state.isDrawerOpen = false;
    }

    this.loginSettings = GetControlPropertyFromStoreOrRefData("[_userinfo]");
    this.primaryColor = appTheme?.palette?.primary?.main;
    this.thisYear = new Date().getFullYear();
    this.isIOS =
      navigator.userAgent && /iPad|iPhone|iPod/.test(navigator.userAgent);
    this.handleWindowClick = this.handleWindowClick.bind(this);
  }

  async componentDidMount() {
    let DrawerVisibility = localStorage.getItem("wasDrawerVisible");
    if (DrawerVisibility == "true") {
      this.props.setWidthFunc(true, this?.props?.uiDirection);
    } else {
      this.props.setWidthFunc(false, this?.props?.uiDirection);
    }
    window.addEventListener("click", this.handleWindowClick);
  }

  componentWillUnmount() {
    // Clean up event listener
    window.removeEventListener("click", this.handleWindowClick);
  }

  isDescendantOf(target, className) {
    const parent = target.closest(`.${className}`);
    return parent !== null;
  }

  handleWindowClick(event) {
    event.stopPropagation(); // Stops the click event from bubbling up
    if (
      this.currentMenuRef.current &&
      !this.currentMenuRef.current.contains(event.target) &&
      !this.isDescendantOf(event.target, "drawer-list")
    ) {
      this.setState({
        // currentMenu: null,
        openedMenus: [],
      });
    }
  }

  toggleDrawer(isDrawerOpen) {
    if (isDrawerOpen && this.state.isDrawerOpen) {
      isDrawerOpen = false;
    }
    this.props.setWidthFunc(isDrawerOpen, this?.props?.uiDirection);

    this.setState({ isDrawerOpen }, () => {
      localStorage.setItem("wasDrawerVisible", this.state.isDrawerOpen);
    });
  }

  async menuItemClickForGlobalSearch(menuItem, hasChildren, isMenuOpen) {
    if (hasChildren) {
      if (isMenuOpen) {
        this.setState({
          openedMenus: this.state.openedMenus.filter(
            (t) => t !== menuItem.menuid
          ),
        });
      } else {
        this.setState({
          openedMenus: [...this.state.openedMenus, menuItem.menuid],
        });
      }
    } else {
      if (this.props) {
        if (
          this.props?.drawerVariant?.drawerVariantValue?.drawerVariantValue !=
          "persistent"
        ) {
          this.state.isDrawerOpen = false;
          this.props.setWidthFunc(false, this?.props?.uiDirection);
        } else {
          this.props.setWidthFunc(true, this?.props?.uiDirection);
          this.state.isDrawerOpen = true;
        }
      }

      window.history.pushState({}, "", "#/" + (menuItem?.permalink ?? ""));

      await ExecuteLayoutEventMethods(
        [
          {
            exec: "setdataset",
            args: {
              dset: "pagemenuinfo",
              data: menuItem,
            },
          },
        ],
        null,
        null,
        true
      );
      await ExecuteLayoutEventMethods(menuItem?.action, null, null, true);

      // this.props.executeMenuRouting({
      //     doctype: "page",
      //     docno: hash
      // });
    }
  }

  async menuItemClick(menuItem, hasChildren, menuLevel) {
    if (this.DrawerVisibility) {
    }
    if (menuLevel == this.state.currentSubmenuId) {
      let array = this.state.openedMenus;
      array.pop();
      this.setState({
        openedMenus: array,
      });
    }

    this.setState({
      currentSubmenuId: menuLevel,
    });

    if (!hasChildren) {
      this.setState({
        openedMenus: [],
      });

      if (menuItem?.permalink) {
        window.history.pushState({}, "", "#/" + (menuItem?.permalink ?? ""));
      }
      await ExecuteLayoutEventMethods(
        [
          {
            exec: "setdataset",
            args: { dset: "pagemenuinfo", data: menuItem },
          },
        ],
        null,
        null,
        true
      );
      await ExecuteLayoutEventMethods(menuItem?.action, null, null, true);
      return;
    }

    if (menuItem.parentid == 0) {
      this.setState({
        openedMenus: [menuItem.menuid],
      });
      // await ExecuteLayoutEventMethods(
      //   [
      //     {
      //       exec: "setdataset",
      //       args: { dset: "pagemenuinfo", data: menuItem },
      //     },
      //   ],
      //   null,
      //   null,
      //   true
      // );
      // await ExecuteLayoutEventMethods(menuItem?.action, null, null, true);
      return;
    }
    if (hasChildren) {
      const { openedMenus } = this.state;
      const isMenuOpen = openedMenus.includes(menuItem.menuid);

      this.setState({
        openedMenus: isMenuOpen
          ? openedMenus.filter((id) => id !== menuItem.menuid)
          : [...openedMenus, menuItem.menuid],
      });
    } else {
      if (this.props) {
        if (this.props?.drawerVariant?.drawerVariantValue !== "persistent") {
          this.setState({ isDrawerOpen: false });
          this.props.setWidthFunc(false, this?.props?.uiDirection);
        }
      }

      window.history.pushState({}, "", "#/" + (menuItem?.permalink ?? ""));
      await ExecuteLayoutEventMethods(
        [
          {
            exec: "setdataset",
            args: { dset: "pagemenuinfo", data: menuItem },
          },
        ],
        null,
        null,
        true
      );
      await ExecuteLayoutEventMethods(menuItem?.action, null, null, true);
    }
  }

  render() {
    let scaff = new PureJSComponentFactory().scaffoldComponent(this.props.chld);
    let scafftitle = new PureJSComponentFactory().scaffoldComponent(
      this.props.titlepart
    );
    let appTitle = GetControlPropertyFromStoreOrRefData(this.props.title);
    let logoMime = "data:image/png;base64,";
    let factsLogo =
      "iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JQAAgIMAAPn/AACA6QAAdTAAAOpgAAA6mAAAF2+SX8VGAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH5AcGCgEBtcH0+QAAAzBJREFUOMtNk0tvG2UYhZ/3mxnf4jixg+3EkKRZQC8gLlEpqhAEFakskZDaHb+Bn8IWiV8AQgIBEmGDqEAIsqlQKbAozYWQ2I4v8dge2/PNfC+LpFGPdDav9J7NeY6MRiMAUUVE8IwQ+J7JBIHkMaYIWtJUK6MoqXZCu3zcjRu7zUl5NElaH7xV+9wXIV8o+EWQMs6Vp7Gr9Ia22j6NV467s8ZRb/Zs59TWe0Nb7Q9teThJi9E0zTSWsv+8/2btN98munbvfm/ruDu7cXJqL3WHttYf2ko4TkrRLM3H1vmpA+VMAiiK50kBJe+HUfLSF/daHx12ZledU3GqOMeFRM5sRC5uqoKAATW+QD11Wk5SFYCMb1ivF9hYKZDPGoZRyuPjMYcnU5LUXQTpuX0R8UUQVWWtlufWZpXVWo6XN4p0Bpb7j0KuX14kjCzbO232mtGTAFFFjIJNU9KNlQLvblZ5uBciqmREqZU8TkeWT77e4/FRxIe3V7n5YgVVUKeqivpJ4sbl+cBeWS/x3U6b+bzHldU5cI7ACDevLbK90+b7nTa7zYi77zRQhaPOxCmkJk5cfHm16Fq9KYcnE8rzAdnAoCiqMJfzyGU9jBH+3h/x+6OQrVeWyPhGnVNnsoHJ/nUw8pYrOS4tF+gMYiZxiiAYI4RRQjRNUZQ3ri7y6vMLfPNLk6lNjQie8TxTGIys/+ufPW5fr1Kv5Phjb4Qaw8QqPz/oM5fzuLPV4L0bNb786ZiHu0OMiAcEvkDgeeLtNyds77S5tVnF8zwiC71hwmq9wLWNEv+2J3z67T7t/gwxgpy34KtqoqoqRmj2Znz2w380nsnxXDVHPusRjhP2WxEngxgUjBGcXpApvkLLM9IPPKmnTk3ilP1mdNH3EwpFzjl+ClIAv1TwH9zZqn/c7MevdwZ2rX+2haXBOFkYT9P8zLpMkqo4fepLFcABqR/4cvD2a5WvQH5EddFaVw7HyVI3tLVWP15p9mYrnUFc7w2TWje0S+E4mR9OkoJTHSWp9n1VpuNxMlOlBxhjCObzXlApBbkX1ucKIEVUF2zslgbjpHoyiOsH7eliL7TdXMbs/g/Z+L2xtJFi0QAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMC0wNy0wNlQxMDowMTowMS0wNDowMJiycesAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjAtMDctMDZUMTA6MDE6MDEtMDQ6MDDp78lXAAAAAElFTkSuQmCC";
    return (
      <React.Fragment>
        <AppBar
          position="static"
          style={this.props?.style}
          className={appTheme.appbarClass}
        >
          <Toolbar className={appTheme.appToolbarClass}>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => {
                this.toggleDrawer(true);
              }}
            >
              <MenuIcon />
            </IconButton>
            {appTitle ? (
              <Typography variant="h6" className="flex-grow">
                {appTitle}
              </Typography>
            ) : (
              <></>
            )}
            {scafftitle}
            {this.props.pageInfo?.globalsearchfield ? (
              <FactsGlobalSearchField
                pageInfo={this.props.pageInfo}
                userMenu={this.props.userMenu}
                menuDropClick={this.menuItemClickForGlobalSearch}
              ></FactsGlobalSearchField>
            ) : (
              <></>
            )}
            {scaff}
          </Toolbar>
        </AppBar>

        <Drawer
          anchor={this?.props?.uiDirection === "ltr" ? "left" : "right"}
          open={this.state.isDrawerOpen}
          onClose={() => this.toggleDrawer(false)}
          onOpen={() => this.toggleDrawer(true)}
          disableBackdropTransition={!this.isIOS}
          disableDiscovery={this.isIOS}
          disableBackdropClick={true}
          disableSwipeToOpen={this.props?.disableswipe}
          classes={{ paper: "app-drawer" }}
          // setWidthFunc={appDrawerWidth}
          variant={
            this.props?.drawerVariant?.drawerVariantValue?.drawerVariantValue
          }
        >
          <div
            className="drawer-header"
            style={{
              padding: "5px 10px 10px 10px",
              display: "flex",
              alignItems: "start",
              boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px",
            }}
          >
            <img
              style={{ maxWidth: "200px", maxHeight: "100px" }}
              src={loginImage}
              alt="factshrcloudLogo"
            />

            <div style={{ display: "block" }}>
              <div
                style={{
                  color: "#000",
                  fontSize: "10px",
                  paddingBottom: "5px",
                  paddingLeft: "10px",
                  fontWeight: "500",
                }}
              >
                {this.loginSettings?.userdesig ?? ""}
              </div>
            </div>
          </div>
          <List className="drawer-list">
            {this.props.userMenu
              ?.filter(
                (t) =>
                  t.parentid?.toString() === "0" &&
                  t.showinmenu.toString() === "1"
              )
              ?.map((menuItem, index) => this.getmenuItem(menuItem, index, 0))}
          </List>
          <div className="copyright">
            <div className="copyright-holder">
              <img alt="FACTS" src={logoMime + factsLogo}></img>
              <a href="https://facts.ae">
                FACTS LLC &copy; {this.thisYear} All Rights Reserved
              </a>
            </div>
            {versionDatetime && (
              <div className="last-updated">
                Version: {versionDatetime}
              </div>
            )}
          </div>
        </Drawer>
      </React.Fragment>
    );
  }

  getmenuItem(menuItem, index, menuLevel) {
    const { openedMenus } = this.state;
    const hasChildren = this.props.userMenu?.some(
      (t) => t.parentid?.toString() === menuItem.menuid
    );

    const isMenuOpen = openedMenus.includes(menuItem.menuid); // Check from state

    return (
      <React.Fragment key={index}>
        <ListItem
          tabIndex={"-1"}
          className={`drawer-list-item drawer-list-menu-${menuLevel + 1}`}
          dense={true}
          style={{ display: "flex", alignItems: "center" }}
          button
          onClick={() => this.menuItemClick(menuItem, hasChildren, menuLevel)}
        // onMouseEnter={() => this.menuItemClick(menuItem, hasChildren, menuLevel)}
        // style={{ paddingLeft: `${10 * (menuLevel + 1)}px` }}
        >
          <ListItemIcon
            className="drawer-list-itemicon"
            style={{ minWidth: "30px" }}
          >
            <Icon className="drawer-list-icon">{menuItem.icon}</Icon>
          </ListItemIcon>
          <ListItemText primary={t(menuItem.caption) || menuItem.caption} />

          {hasChildren && (
            <Icon>
              {isMenuOpen ? <KeyboardArrowRightIcon /> : "expand_more"}
            </Icon>
          )}
        </ListItem>
        {hasChildren && isMenuOpen && (
          <div
            ref={this.currentMenuRef}
            className="sidemenu-submenu"
            style={{
              ...(this.props.uiDirection === 'ltr'
                ? { left: `${250 + 245 * menuLevel}px` }
                : { right: `${250 + 245 * menuLevel}px` }),
              maxHeight: "70vh",
              overflowY: "scroll",
              backgroundColor: "#fff",
              minWidth: "240px",
              maxWidth: "240px",
              border: "1px solid #eae8e8",
              top: "100px",
              position: "fixed",
              padding: "5px",
              boxShadow:
                "rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px, rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px, rgba(0, 0, 0, 0.07) 0px 16px 16px",
            }}
          >
            <div
              style={{
                padding: "5px 10px",
                fontSize: "14px",
                position: "sticky",
                top: "-10px",
                zIndex: "100",
              }}
              className="submenuCaption"
            >
              {t(menuItem.caption) || menuItem.caption}
            </div>
            <List className="drawer-list">
              {this.props.userMenu
                ?.filter(
                  (t) =>
                    t.parentid?.toString() === menuItem.menuid &&
                    t.showinmenu.toString() === "1"
                )
                ?.map((submenuItem, subIndex) =>
                  this.getmenuItem(submenuItem, subIndex, menuLevel + 1)
                )}
            </List>
          </div>
        )}
        {/* {menuLevel === 0 && <Divider />} */}
      </React.Fragment>
    );
  }
}

export default AppBarComponentDTP;
